<template>
  <div :style="cssVariables">
    <div class="header my-2">
      Preview
    </div>
    <div class="pa-6">
      <h3 class="headline">Headline Text Color</h3>
      <p>
        Text color example: Lorem ipsum dolor sit amet,
        <a href="/">LINK</a>
        adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
      </p>

      <v-row>
        <v-col md="3">
          <div class="preview-score-card preview-score-card--primary">
            <div class="preview-score-card__header">
              Primary Color
            </div>
            <div class="preview-score-card__graph">
              <v-sparkline :value="sparkValue" color="white" line-width="2" padding="16" />
            </div>
            <div class="preview-score-card__subtitle">
              Subtitle
            </div>
          </div>
        </v-col>
        <v-col md="3">
          <div class="preview-score-card preview-score-card--secondary">
            <div class="preview-score-card__header">
              Secondary Color
            </div>
            <div class="preview-score-card__graph">
              <v-sparkline :value="sparkValue" color="white" line-width="2" padding="16" />
            </div>
            <div class="preview-score-card__subtitle">
              Secondary Accent Color
            </div>
          </div>
        </v-col>
        <v-col md="6">
          <v-btn class="d-block mb-4" :color="colorsMap['primary']" :style="`color: ${colorsMap['on-primary']}`">
            Primary Color Button
          </v-btn>
          <v-btn :color="colorsMap['secondary']" :style="`color: ${colorsMap['on-secondary']}`">
            Secondary Color Button
          </v-btn>

          <v-row>
            <v-col sm="6">
              <v-radio-group :value="1">
                <v-radio v-for="n in 3" :key="n" :label="`Secondary ${n}`" :value="n" :color="colorsMap['secondary']" />
              </v-radio-group>
            </v-col>
            <v-col sm="6">
              <v-switch :value="true" :inputValue="true" inset :color="colorsMap['primary']" label="Primary switch" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    colors: { type: Array, required: true },
  },

  data() {
    return {
      sparkValue: [
        200,
        675,
        410,
        390,
        310,
        460,
        250,
        240,
      ]
    }
  },

  computed: {
    cssVariables() {
      return this.colors.map(color => {
        return `--q-${color.name}: ${color.value};`;
      }).join("");
    },
    colorsMap() {
      return this.colors.reduce((acc, color) => {
        acc[color.name] = color.value;
        return acc;
      }, {});
    },
  }
}
</script>

<style lang="scss" scoped>
.header {
  font: normal normal normal 25px/20px Montserrat;
  background: var(--q-primary);
  color: var(--q-on-primary);
  padding: 1rem;
}

.headline {
  // color: var(--q-text-headline);
  font: normal normal normal 25px/25px Montserrat;
}

a {

  &,
  &:hover,
  &:focus {
    color: var(--q-text-link);
  }

  &:hover {
    filter: brightness(120%);
  }
}

.preview-score-card {
  & > * {
    background: var(--q-preview-graph);
    color: var(--q-preview-on-graph);
    margin-bottom: 4px;
    padding: 4px 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__graph {
    background: var(--q-preview-graph-1);
    color: var(--q-preview-on-graph-1);
  }

  &__subtitle {
    background: var(--q-preview-graph-2);
    color: var(--q-preview-on-graph-2);
  }

  &--primary {
    --q-preview-graph: var(--q-primary);
    --q-preview-on-graph: var(--q-on-primary);
    --q-preview-graph-1: var(--q-primary-tint-1);
    --q-preview-graph-2: var(--q-primary-tint-2);
    --q-preview-on-graph-1: var(--q-on-primary-tint-1);
    --q-preview-on-graph-2: var(--q-on-primary-tint-2);
  }

  &--secondary {
    --q-preview-graph: var(--q-secondary);
    --q-preview-on-graph: var(--q-on-secondary);
    --q-preview-graph-1: var(--q-secondary-tint-1);
    --q-preview-graph-2: var(--q-secondary-tint-2);
    --q-preview-on-graph-1: var(--q-on-secondary-tint-1);
    --q-preview-on-graph-2: var(--q-on-secondary-tint-2);
  }
}
</style>